import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#0b1523",
        color: "#ffffff",
        padding: "40px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "left",
        }}
      >
        {/* Product Section */}
        <div>
          <h4 style={{ marginBottom: "20px", fontSize: "16px" }}>PRODUCT</h4>
          <ul style={{ listStyleType: "none", padding: 0, lineHeight: "2" }}>
            <li>
              <Link to="/marketplace" style={{ color: "#ffffff", textDecoration: "none" }}>
                Marketplace
              </Link>
            </li>
            <li>
              <Link to="/rent" style={{ color: "#ffffff", textDecoration: "none" }}>
                Rentals
              </Link>
            </li>
            <li>
              <Link to="/rankings" style={{ color: "#ffffff", textDecoration: "none" }}>
                Rankings
              </Link>
            </li>
          </ul>
        </div>

        {/* Company Section */}
        <div>
          <h4 style={{ marginBottom: "20px", fontSize: "16px" }}>COMPANY</h4>
          <ul style={{ listStyleType: "none", padding: 0, lineHeight: "2" }}>
            <li>
              <Link to="/how-it-works" style={{ color: "#ffffff", textDecoration: "none" }}>
                How It Works
              </Link>
            </li>
            <li>
              <Link to="/why-cars" style={{ color: "#ffffff", textDecoration: "none" }}>
                Why Cars
              </Link>
            </li>
            <li>
              <Link to="/about" style={{ color: "#ffffff", textDecoration: "none" }}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" style={{ color: "#ffffff", textDecoration: "none" }}>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/feedback" style={{ color: "#ffffff", textDecoration: "none" }}>
                Feedback
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal Section */}
        <div>
          <h4 style={{ marginBottom: "20px", fontSize: "16px" }}>LEGAL</h4>
          <ul style={{ listStyleType: "none", padding: 0, lineHeight: "2" }}>
            <li>
              <Link to="/terms-of-service" style={{ color: "#ffffff", textDecoration: "none" }}>
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" style={{ color: "#ffffff", textDecoration: "none" }}>
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Social Section */}
        <div>
          <h4 style={{ marginBottom: "20px", fontSize: "16px" }}>SOCIAL</h4>
          <ul style={{ listStyleType: "none", padding: 0, lineHeight: "2" }}>
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "none" }}>
                Facebook
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "none" }}>
                Twitter
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "none" }}>
                Instagram
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "none" }}>
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Call to Action */}
      <div
        style={{
          marginTop: "40px",
          fontSize: "1.2rem",
          color: "#ffffff",
          textAlign: "center",
        }}
      >
        <p>
          <strong>Interested in investing? </strong>
          <Link
            to="/contact"
            style={{
              color: "#007bff",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Contact Us now
          </Link>
          .
        </p>
      </div>

      {/* Footer Disclaimer */}
      <div
        style={{
          marginTop: "20px",
          fontSize: "12px",
          color: "#cccccc",
          textAlign: "center",
        }}
      >
        <p>
          &copy; {new Date().getFullYear()} GIER. All rights reserved.
        </p>
        <p>
          None of the information on this website should be construed as investment, financial, tax, or legal advice.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
